<template lang="html">
  <div class="outfit-stitch-wrapper"
  @mouseenter="toggleStitchHover"
    @mouseleave="toggleStitchHover"
  >
    <div class="outfit-stitch-stack" :class="{ 'has-stitch': hasStitch }">
      <a class="outfit-stitch-link" v-on:click.prevent.stop="submitStitchRequest()">
        <HeartIcon
          width="20px"
          height="20px"
          :hovering="stitchHovering"
          :stitched="hasStitch"
          class="heart-icon float-right"
        />
      </a>
      <span class="outfit-stitch-count">
        {{ outfit.stitches_count }}
      </span>
    </div>
  </div>
</template>

<script>
import HeartIcon from "@/components/showCapsule/icons/Heart";
import { mapActions, mapGetters } from "vuex";
import { bus } from "@/main";

export default {
  components: {
    HeartIcon,
  },

  data() {
    return {
      stitchHovering: false,
    };
  },

  props: {
    outfit: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapGetters(["allStitches", "currentUser"]),

    hasStitch() {
      return this.allStitches.includes(this.outfit.id);
    },
  },

  methods: {
    ...mapActions(["stitchDiscoverOutfit", "unstitchDiscoverOutfit"]),

    submitStitchRequest() {
      if (this.currentUser !== null) {
        this.hasStitch
          ? this.unstitchDiscoverOutfit(this.outfit)
          : this.stitchDiscoverOutfit(this.outfit);
      } else {
        bus.$emit("openSignUpModal");
      }
    },

    toggleStitchHover() {
      this.stitchHovering = !this.stitchHovering;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";

.outfit-stitch-wrapper {
  text-align: center;
  // padding-right: 10px;
  padding-right: 0px;
  padding-left: 10px;
}

.outfit-stitch-wrapper > .outfit-stitch-stack {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}

.outfit-stitch-wrapper > .outfit-stitch-stack > .outfit-stitch-link {
  padding-right: 8px;
  padding-left: 8px;
  cursor: pointer;
  text-align: center;
  padding-top: 5px;
  padding-bottom: 5px;

  &:hover {
    border-radius: 3px;
    background: $grey5;

    .outfit-stitch {
      color: $alizarin;
    }
  }
}

.outfit-stitch-wrapper
  > .outfit-stitch-stack:not(.has-stitch)
  > .outfit-stitch-link:hover
  > .outfit-stitch {
  opacity: 0.5;
}

.outfit-stitch-wrapper
  > .outfit-stitch-stack.has-stitch
  > .outfit-stitch-link:hover
  > .outfit-stitch {
  opacity: 1;
}

.outfit-stitch-wrapper
  > .outfit-stitch-stack
  > .outfit-stitch-link
  > .outfit-stitch {
  color: $grey3;
  font-size: 20px;
  line-height: 32px;
  opacity: 1;
}

.outfit-stitch-wrapper > .outfit-stitch-stack > .outfit-stitch-count {
  color: $grey3;
  text-transform: uppercase;
  // letter-spacing: 1.4px;
  letter-spacing: -1px;
  font-size: 11px;
  font-weight: 400;
  margin-bottom: 5px;
  text-align: center;

  &.no-votes {
    font-weight: 300;
  }
}

.outfit-stitch-wrapper > .outfit-stitch-stack.has-stitch > .outfit-stitch-count,
.outfit-stitch-wrapper
  > .outfit-stitch-stack.has-stitch
  > .outfit-stitch-link
  > .outfit-stitch {
  color: $alizarin;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/discover/StitchButton.vue